{
	"language": {
		"aria": "Zmień język"
	},
	"placeholder": {
		"title": "Twoje centrum kandydata jest już w drodze",
		"body": "Nie ma tu jeszcze nic. Gdy wszystko będzie gotowe, wyślemy Ci link e-mailem."
	},
	"not_found": {
		"title": "Nie znaleziono strony",
		"body": "Sprawdź link, w który kliknąłeś, lub skorzystaj z linku z wiadomości e-mail."
	},
	"error_boundary": {
		"reload": "Załaduj stronę ponownie"
	},
	"login": {
		"loading": "Ładowanie…",
		"title": "Zaloguj się do swojego centrum kandydata",
		"intro": "Podaj swój adres e-mail, aby zobaczyć swoje aplikacje.",
		"email_label": "Adres e-mail",
		"email_placeholder": "ty@przyklad.com",
		"submit": "Zaloguj się",
		"sending": "Wysyłanie…",
		"sent": {
			"title": "Sprawdź swoją skrzynkę e-mail",
			"body": "Jeśli adres {{email}} pasuje do aplikacji, link do logowania jest już w drodze.",
			"retry": "Nie otrzymałeś go? Sprawdź adres i spróbuj ponownie"
		},
		"resent": {
			"title": "Wysłaliśmy Ci nowy link do logowania",
			"body": "Otwarty link wygasł. Jeśli Twój adres e-mail pasuje do aplikacji, nowy link do logowania jest już w drodze. Otworzy tę samą stronę.",
			"request_manually": "Nie otrzymałeś go? Poproś o nowy link"
		},
		"request_error": {
			"throttled": "Zbyt wiele prób. Odczekaj chwilę i spróbuj ponownie.",
			"invalid_email": "Podaj prawidłowy adres e-mail.",
			"generic": "Coś poszło nie tak. Spróbuj ponownie."
		},
		"unknown_organisation": {
			"title": "Nie znaleziono strony",
			"body": "Sprawdź link, w który kliknąłeś, lub skorzystaj z linku z wiadomości e-mail."
		},
		"error": {
			"title": "Coś poszło nie tak",
			"body": "Nie udało nam się załadować tej strony. Spróbuj ponownie za chwilę."
		}
	},
	"organisations": {
		"title": "Twoje aplikacje",
		"intro": "Wybierz firmę, aby zobaczyć aplikacje, które do niej wysłałeś.",
		"count_one": "{{count}} aplikacja",
		"count_few": "{{count}} aplikacje",
		"count_many": "{{count}} aplikacji",
		"count_other": "{{count}} aplikacji",
		"empty": {
			"title": "Brak aplikacji",
			"body": "Gdy zaaplikujesz do firmy, pojawi się ona tutaj."
		},
		"error": "Nie udało nam się załadować Twoich firm. Spróbuj ponownie za chwilę.",
		"log_out": "Wyloguj się",
		"logging_out": "Wylogowywanie…"
	},
	"submissions": {
		"title": "Poprzednie aplikacje",
		"back_to_organisations": "Wszystkie firmy",
		"cv_uploaded": "CV przesłane",
		"empty": {
			"title": "Brak aplikacji",
			"body": "Aplikacje, które wyślesz do {{organisation}}, pojawią się tutaj."
		},
		"error": "Nie udało nam się załadować Twoich aplikacji. Spróbuj ponownie za chwilę.",
		"log_out": "Wyloguj się",
		"logging_out": "Wylogowywanie…"
	},
	"profile": {
		"link": {
			"title": "Twój profil",
			"cv_added": "CV dodane",
			"cv_missing": "Brak CV"
		},
		"back": "Powrót do aplikacji",
		"context": "{{campaign}} · {{organisation}}",
		"contact_consent": "Zgadzasz się na kontakt w sprawie tej oferty pracy.",
		"cv": {
			"title": "CV",
			"upload": {
				"title": "Prześlij swoje CV",
				"drop_hint": "lub przeciągnij i upuść je tutaj",
				"constraints": "{{types}}, maks. {{size}} MB",
				"uploading": "Przesyłanie {{fileName}}…",
				"done": "CV przesłane",
				"error_type": "Ten typ pliku nie jest obsługiwany. Dozwolone typy: {{types}}.",
				"error_size": "Ten plik jest za duży. Maksymalny rozmiar to {{size}} MB."
			},
			"remove": {
				"label": "Usuń {{fileName}}",
				"question": "Usunąć {{fileName}}?",
				"consequence": "Pracodawca nie będzie już mógł go zobaczyć. Tej operacji nie można cofnąć.",
				"confirm": "Usuń CV",
				"cancel": "Anuluj",
				"removing": "Usuwanie…",
				"error": "Nie udało się usunąć CV. Spróbuj ponownie."
			}
		},
		"work_history": {
			"title": "Doświadczenie zawodowe",
			"description": "Opowiedz nam o swoim istotnym doświadczeniu zawodowym: gdzie pracowałeś, czym się tam zajmowałeś i jak długo tam pracowałeś. Możesz dodać więcej niż jedno miejsce pracy, jeśli są istotne.",
			"placeholder": "Opisz pracę, którą wykonywałeś",
			"input_label": "Szczegóły pracy",
			"save": "Zapisz",
			"saving": "Zapisywanie…",
			"cancel": "Anuluj",
			"edit": "Edytuj",
			"remove": "Usuń",
			"add_another": "Dodaj kolejne miejsce pracy",
			"error_empty": "Wpisz coś przed zapisaniem.",
			"error_limit": "Możesz dodać maksymalnie {{max}} miejsc pracy.",
			"unsaved_changes": "Masz niezapisane zmiany w swoim doświadczeniu zawodowym. Czy mimo to chcesz wyjść i je utracić?",
			"hints": {
				"label": "Szczegóły tej pracy",
				"included": "podano",
				"missing": "jeszcze nie podano"
			}
		},
		"education": {
			"title": "Wykształcenie",
			"description": "Opowiedz nam o swoim istotnym wykształceniu: czego się uczyłeś, gdzie i kiedy. Liczą się stopnie, szkoły, kursy i certyfikaty. Możesz dodać więcej niż jeden wpis.",
			"placeholder": "Opisz stopień, szkołę lub kurs",
			"input_label": "Szczegóły wykształcenia",
			"save": "Zapisz",
			"saving": "Zapisywanie…",
			"cancel": "Anuluj",
			"edit": "Edytuj",
			"remove": "Usuń",
			"add_another": "Dodaj kolejne wykształcenie",
			"error_empty": "Wpisz coś przed zapisaniem.",
			"error_limit": "Możesz dodać maksymalnie {{max}} wpisów o wykształceniu.",
			"unsaved_changes": "Masz niezapisane zmiany w swoim wykształceniu. Czy mimo to chcesz wyjść i je utracić?"
		},
		"licenses": {
			"title": "Uprawnienia i certyfikaty",
			"description": "Opowiedz nam o swoich uprawnieniach i certyfikatach, np. prawie jazdy, uprawnieniach na wózek widłowy czy książeczce sanepidowskiej. Podaj, kiedy je uzyskałeś i kiedy wygasają, jeśli wygasają. Możesz dodać więcej niż jeden wpis.",
			"placeholder": "Opisz uprawnienie lub certyfikat",
			"input_label": "Szczegóły uprawnienia",
			"save": "Zapisz",
			"saving": "Zapisywanie…",
			"cancel": "Anuluj",
			"edit": "Edytuj",
			"remove": "Usuń",
			"add_another": "Dodaj kolejne uprawnienie",
			"error_empty": "Wpisz coś przed zapisaniem.",
			"error_limit": "Możesz dodać maksymalnie {{max}} uprawnień.",
			"unsaved_changes": "Masz niezapisane zmiany w swoich uprawnieniach. Czy mimo to chcesz wyjść i je utracić?"
		}
	},
	"submission": {
		"back": "Powrót do moich aplikacji",
		"back_short": "Powrót",
		"not_found": {
			"title": "Nie znaleziono aplikacji",
			"body": "Ta aplikacja nie istnieje lub nie należy do Ciebie."
		},
		"result": {
			"heading": "Ekran potwierdzenia, który zobaczyłeś po wysłaniu aplikacji"
		},
		"summary": {
			"title": "Podsumowanie Twoich odpowiedzi",
			"submitted_on": "Ten formularz wysłałeś dnia",
			"submitted_more_than_once": "Ten formularz wypełniłeś więcej niż raz. Automatycznie połączymy Twój profil; poniższa aplikacja jest najnowsza."
		}
	}
}
